<div cdkOverlayOrigin #trigger="cdkOverlayOrigin" #anchorElementRef role="tooltip" id="popperDiv"     
    class="keylink-container" style="padding: 0px; gap: 8px;cursor : pointer;">
    <a 
		role="button"
		class="nsw-link nsw-link--icon" 
		(click)="onClick()" 
        href="javascript:void(0)"        
		[tabindex]="0"
        [attr.aria-label]="description">        
		<img
            class="tooltip-icon"
            src="assets/images/SystemIcons/info-outline.svg"
            alt="info">
		<span style="padding:10px;">{{description}}</span>				
	</a>    
</div>

<ng-template
    cdkConnectedOverlay   
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="isPopupShown"
    (detach)="closePopup()"    
    (overlayOutsideClick)="closePopup()"> 
    

    <div class="nsw-dialog__wrapper dlg" 
        cdkTrapFocus [cdkTrapFocusAutoCapture]="true" aria-modal="true" 
        aria-labelledby="single-cta-title"
        style="width : 100%; height : 100%;max-width:fit-content;">
        <div class="nsw-dialog__container">
            <div class="nsw-dialog__top">
                <div class="nsw-dialog__title">
                    <h2 id="single-cta-title">{{popupTitle}}</h2>
                </div>
                <div class="nsw-dialog__close">
                <button class="nsw-icon-button js-close-dialog" (click)="onPopupClose(true)">
                    <span class="material-icons nsw-material-icons" focusable="false" aria-hidden="true">close</span>
                    <span class="sr-only">Close</span>
                </button>
                </div>
            </div>
            <div class="nsw-dialog__content">
                <ng-content></ng-content>   
            </div>
        </div>       
    </div>  
</ng-template>  
